/* eslint-disable no-unused-vars */
import JavaScriptLogo from '../../assets/skill-logos/JavaScript-logo.svg';
import HTML5Logo from '../../assets/skill-logos/HTML5-logo.svg';
import CSS3Logo from '../../assets/skill-logos/CSS3-logo.svg';
import ReactLogo from '../../assets/skill-logos/React-logo.svg';
import AngularLogo from '../../assets/skill-logos/Angular-logo.svg';
import SASSLogo from '../../assets/skill-logos/SASS-logo.svg';

import NodeJSLogo from '../../assets/skill-logos/NodeJS-logo.svg';
import ExpressLogo from '../../assets/skill-logos/Express-logo.svg';
import CsharpLogo from '../../assets/skill-logos/Csharp-logo.svg';
import AspNetLogo from '../../assets/skill-logos/AspNet-logo.svg';
import SQLLogo from '../../assets/skill-logos/SQL-logo.svg';
import MongoDB from '../../assets/skill-logos/MongoDB-logo.svg';

import AzureLogo from '../../assets/skill-logos/Azure-logo.svg';
import DevOpsLogo from '../../assets/skill-logos/DevOps-logo.svg';
import GitLogo from '../../assets/skill-logos/git-logo.svg';
import PythonLogo from '../../assets/skill-logos/Python-logo.svg';
import UnityLogo from '../../assets/skill-logos/Unity-logo.svg';
import GodotLogo from '../../assets/skill-logos/Godot-logo.svg';

const skills = [
  {
    category: 'Frontend',
    skills: [
      {
        name: 'JavaScript',
        description: '',
        logo: JavaScriptLogo,
      },
      {
        name: 'HTML5',
        description: '',
        logo: HTML5Logo,
      },
      {
        name: 'CSS3',
        description: '',
        logo: CSS3Logo,
      },
      {
        name: 'React',
        description: '',
        logo: ReactLogo,
      },
      {
        name: 'Angular',
        description: '',
        logo: AngularLogo,
      },
      {
        name: 'SASS',
        description: '',
        logo: SASSLogo,
      },
    ],
  },
  {
    category: 'Backend',
    skills: [
      {
        name: 'NodeJS',
        description: '',
        logo: NodeJSLogo,
        size: 'skills_container__skill-icon-img--large',
      },
      {
        name: 'Express',
        description: '',
        logo: ExpressLogo,
        size: 'skills_container__skill-icon-img--xlarge',
      },
      {
        name: 'C# .NET',
        description: '',
        logo: CsharpLogo,
      },
      {
        name: 'ASP.NET',
        description: '',
        logo: AspNetLogo,
      },
      {
        name: 'SQL',
        description: '',
        logo: SQLLogo,
      },
      {
        name: 'MongoDB',
        description: '',
        logo: MongoDB,
      },
    ],
  },
  {
    category: 'Other',
    skills: [
      {
        name: 'Azure',
        description: '',
        logo: AzureLogo,
      },
      {
        name: 'DevOps',
        description: '',
        logo: DevOpsLogo,
      },
      {
        name: 'Git',
        description: '',
        logo: GitLogo,
      },
      {
        name: 'Python',
        description: '',
        logo: PythonLogo,
      },
      {
        name: 'Unity',
        description: '',
        logo: UnityLogo,
      },
      {
        name: 'Godot',
        description: '',
        logo: GodotLogo,
      },
    ],
  },
];

export default skills;
